import { Component, Inject } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatOption } from "@angular/material/autocomplete";
import { MatSelect } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { ApplicationDataService } from "../../../../core/services/application-data.service";
import { AlertDialogComponent } from "../../../../shared/alert-dialog/alert-dialog.component";

@Component({
  selector: "app-send-sms-dialog",
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatCheckbox,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: "./send-sms-dialog.component.html",
    styleUrl: './send-sms-dialog.component.css'
})
export class SendSmsDialogComponent {
  form: FormGroup;
  TITLE: string;
  SEND_TO_LABEL: string;
  private fullPhoneNumber: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SendSmsDialogComponent>,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private appDataService: ApplicationDataService
  ) {
    this.fullPhoneNumber = data.fullPhoneNumber;
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      sendTo: [
        { value: "", disabled: true },
        [Validators.required, Validators.pattern(/^03\d{9}$/)],
      ],
      complaintId: [""],
      message: ["", [Validators.required]],
    });

    // Set the masked display value
    this.form.patchValue({
      complaintId: this.data.complaintId,
      sendTo: this.data.sendTo,
    });

    this.TITLE = this.data.title;
    this.SEND_TO_LABEL = this.data.sendToLabel;
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }

    // Get form values
    const formValue = this.form.getRawValue();

   
    const { sendTo, ...payloadWithoutSendTo } = formValue;

    this.appDataService.sendSmsService(payloadWithoutSendTo).subscribe((response) => {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: "SMS Sent Successfully!",
          buttonText: {
            cancel: "OK",
          },
        },
      });
      this.dialogRef.close();
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
